import {FilterState} from "../../interfaces/store/reducers/filter";
import {DESTROY_FILTER_DRAWER, SHOW_FILTER_DRAWER} from "../actions/availableActions";
import {DestroyFilterDrawerAction, ShowFilterDrawerAction} from "../../interfaces/store/actions/filter";

const initialState: FilterState = {
    isDrawerVisible: false,
};

type AvailableActions = ShowFilterDrawerAction | DestroyFilterDrawerAction;

const filterReducer = (state: FilterState = initialState, action: AvailableActions): FilterState => {
    switch (action.type) {
        case SHOW_FILTER_DRAWER:
            return {
                isDrawerVisible: true,
                // TODO implement the rest when BE is ready (Daniel)
            };
        case DESTROY_FILTER_DRAWER:
            return {
                isDrawerVisible: false,
                // TODO implement the rest when BE is ready (Daniel)
            };
        default:
            return state;
    }
};

export default filterReducer;
